import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  loadIndexAutomix, setRandomAutomix, setPlayAutomix, setNextInQueueAutomix
} from "../../automix/redux/actions/index";

const useCoverFlow = (height, onFullScreen) => {
  const dispatch = useDispatch();
  const uidAutomix = useSelector(state => state.uidAutomix);
  const isAutomix = useSelector(state => !!state.uidAutomix);
  const playlists = useSelector(state => state.playlistAutomix);
  const isSettingHideAutomix = useSelector(state => state.isSettingHideAutomix);
  const bpmAutomix = useSelector(state => state.bpmAutomix);
  const autoBpmAutomix = useSelector(state => state.autoBpmAutomix);
  const isRandom = useSelector(state => state.isRandomAutomix);
  const dimension = useSelector(state => state.dimension);
  const { playerCoordinates } = dimension;
  const currentIdAutomix = useSelector(state => state.currentIdAutomix);
  const stateAutomix = useSelector(state => state.stateAutomix);
  const [isNext, setIsNext] = useState(null);
  const [active, setActive] = useState(0); // null
  const indexAutomix = useSelector(state => state.loadIndexAutomix);

  if (playerCoordinates && height > 150) {
    if (document.getElementById(playerCoordinates.playerID)) {
      document.getElementById(playerCoordinates.playerID).style[`z-index`] = (isAutomix && !isSettingHideAutomix) ? 0 : 80;
    }
    // Performance CPU USED 80% -> 15%
    if (document.getElementById(`player`)) {
      document.getElementById(`player`).style.display = (isAutomix && !isSettingHideAutomix) ? `none` : `initial`;
    }
  } else if (playerCoordinates && height < 150) { // Switching to & from Compact view is causing the decks to disappear for some users
    const playerEl = document.getElementById(`player`);
    if(playerEl && playerEl.style.display === `none`) {
      document.getElementById(`player`).style.display = `initial`;
    }
  }
  
  // Loading from outside the scope.
  useEffect( () => {
    if (indexAutomix !== null && isNext === null && active !== null) {
      setActive(indexAutomix);
    }
  }, [indexAutomix, active, isNext])

  useEffect( () => {    
    const iCurrent = playlists.tracks.findIndex( x => x.id === currentIdAutomix);
    if (playlists.active === iCurrent && playlists.active !== active) {
      // console.log(`*** AUTOMIX - USECOVERFLOW - EMERGENCY NO MIXIN STATE ***`, iCurrent)
      setActive(iCurrent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentIdAutomix])

  // POSITION OF THE CURRENT TRACK
  useEffect(() => {
    if ((stateAutomix === 'mixing' || stateAutomix === 'skipping') && isNext !== null && active !== null && playlists) {
      let index = isNext ? active + 1 : active - 1;
      index = (index < 0) ? 0 : index;
      // console.log('AUTOMIX - USECOVERFLOW - CHECK POSITION', playlists.active, index)
      if (index === playlists.active) {
        setActive(index);
        setIsNext(null);
        // console.log('AUTOMIX - USECOVERFLOW setActive INDEX from to ', active, index)
      }
    }
  }, [stateAutomix, isNext, currentIdAutomix, active, playlists])

  const toggle = () => {
    window['YouDJ'] && window['YouDJ'].automix_toggle(uidAutomix);
    onFullScreen(null, false);
  }

  const autoBPM = () => {
    window['YouDJ'] && window['YouDJ'].automix_autobpm(!autoBpmAutomix);
  }
  const setBPM = (val) => (isDown) => {
    window['YouDJ'] && window['YouDJ'].automix_bpm_change(val, isDown);
  }

  const callPlay = () => {
    window['YouDJ'] && window['YouDJ'].automix_playpause();
    dispatch(setPlayAutomix(true));
  }

  const callPause = () => {
    window['YouDJ'] && window['YouDJ'].automix_playpause();
    dispatch(setPlayAutomix(false));
  }

  const callNext = () => {
    window['YouDJ'] && window['YouDJ'].automix_next();
  }

  const prepareNext = (isMixing = false) => () => {
    if (isMixing) {
      setTimeout(() => { callNext() }, 10) // Long Transition : possible to quickly cut the transition
    } else {
      setTimeout(() => { callNext() }, 10 /*1400*/)
    }
    setIsNext(true);
  }

  const callLoad = () => { // LOAD THE SELECTED AND NOT THE NEXT
    if (active !== null) {
      setActive(active);
      dispatch(loadIndexAutomix(active));
      setTimeout(() => { callNext() }, 100)
    }
  }
 
  const preparePrevious = () => {
    if (active > 0 && active !== null) {
      dispatch(loadIndexAutomix(playlists.active - 1)); //previous logic use => active 
      setTimeout(() => { callNext() }, 10 /*500*/)
    }
    setIsNext(false);
  }

  const toggleRandom = () => { // Shuffle only next after active
    dispatch(setRandomAutomix(!isRandom));
  }

  const nextInQueue = (index) => () => {
    dispatch(setNextInQueueAutomix(index));
    setActive(playlists.active + 1);
  }

  const clickItem = (i) => () => setActive(i);

  return { 
    uidAutomix, isAutomix, playlists, bpmAutomix, autoBpmAutomix, isRandom,
    active, isSettingHideAutomix,
    setActive,toggle, autoBPM, setBPM, callPlay, callPause, prepareNext, callLoad, 
    preparePrevious, toggleRandom, nextInQueue, clickItem,
  };
};

export default useCoverFlow;
